import { Alert } from '@/components';
import { AlertProps } from '@/interfaces';
import { FC } from 'react';
const SuccessAlert: FC<AlertProps> = ({
  title = 'Success',
  icon = 'check',
  description = 'This is just a success message, but we are so glad you are here.',
  ...props
}) => {
  return (
    <Alert
      intent="success"
      icon={icon}
      title={title}
      description={description}
      {...props}
    />
  );
};
export default SuccessAlert;
